import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { UserName } from "./UserName.js";
import { useUsers } from "../hooks/useUsers.js";
import "react";
import { Avatar, Skeleton } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Users/shared/UserNameWithAvatar.tsx
var UserNameWithAvatar = ({ userId }) => {
	const { data, loading } = useUsers(userId && { idFilter: [userId] });
	if (!data?.users && loading) return /* @__PURE__ */ jsx(Skeleton, {
		height: 20,
		width: 40
	});
	if (!userId?.length || !data?.users) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "gap-x-xs inline-flex",
		children: data.users.map((user) => /* @__PURE__ */ jsxs("div", {
			className: "gap-x-xxs inline-flex items-center",
			children: [/* @__PURE__ */ jsx(Avatar, {
				circular: true,
				url: getTHERMSImageThumbnailUrl(user.avatarUrl),
				size: "xxs"
			}), /* @__PURE__ */ jsx(UserName, { user })]
		}, user.id))
	});
};
//#endregion
export { UserNameWithAvatar };

//# sourceMappingURL=UserNameWithAvatar.js.map